<template>
  <div class="sli">
    <picture-input
      :key="pictureKey"
      ref="pictureInput"
      radius="12"
      :width="size"
      :height="size"
      :size="maxFileSize"
      :crop="false"
      accept="image/*"
      :prefill="prefill"
      :prefill-options="prefillOptions"
      :alert-on-error="false"
      :hide-change-button="false"
      :custom-strings="strings"
      :customStrings="strings"
      @change="onPictureChange"
      @prefill="onPrefillOk"
      @error="onPictureError"
    />
    <p v-if="processing" class="sli-status">Shrinking photo…</p>
    <p v-else class="sli-status">{{ statusText }}</p>
  </div>
</template>
<script>
import PictureInput from "vue-picture-input";
import { processShopLogoImage, formatBytes } from "@/helpers/imageProcess";

const MAX_EDGE = 800;
const JPEG_QUALITY = 0.85;

export default {
  components: { PictureInput },
  props: {
    value: String,
    size: {
      type: String,
      default: "180"
    },
    maxFileSize: {
      type: String,
      default: "12"
    }
  },
  data() {
    return {
      processing: false,
      lastByteLength: null,
      pictureKey: "logo",
      strings: {
        drag: "Add a logo",
        change: "Change logo",
        tap: "Add a logo"
      }
    };
  },
  computed: {
    prefill() {
      return this.value || null;
    },
    prefillOptions() {
      if (this.value && String(this.value).startsWith("http")) {
        return {
          fileName: "shop-logo.jpg",
          mediaType: "image/jpeg"
        };
      }
      return {};
    },
    statusText() {
      if (this.lastByteLength == null) {
        return "We’ll shrink large photos so they load quickly.";
      }
      return `Ready · ${formatBytes(this.lastByteLength)}`;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(next, prev) {
        if (!next || next === prev) return;
        if (next.startsWith("http")) {
          this.pictureKey = next;
        }
      }
    }
  },
  methods: {
    async onPictureChange(base64String) {
      if (!base64String) {
        this.lastByteLength = null;
        this.$emit("input", null);
        return;
      }
      this.processing = true;
      try {
        const result = await processShopLogoImage(base64String, {
          maxEdge: MAX_EDGE,
          quality: JPEG_QUALITY
        });
        this.lastByteLength = result.byteLength;
        this.$emit("input", result.dataUrl);
      } catch (e) {
        this.$emit("error", {
          message:
            (e && e.message) || "Could not process this logo. Try another file."
        });
      } finally {
        this.processing = false;
      }
    },
    onPrefillOk() {},
    onPictureError(e) {
      this.$emit("error", {
        message:
          (e && e.message) ||
          "Could not load logo. You can still upload a new one.",
        type: e && e.type
      });
    }
  }
};
</script>
<style scoped>
.sli {
  display: grid;
  justify-items: start;
  gap: 8px;
  max-width: 220px;
}

.sli-status {
  margin: 0;
  color: #7a7268;
  font-size: 12px;
  line-height: 1.35;
}

.sli ::v-deep .picture-input {
  margin: 0;
}

.sli ::v-deep .picture-preview,
.sli ::v-deep .picture-inner {
  border-radius: 16px !important;
  border: 0 !important;
  box-shadow: inset 0 0 0 1px rgba(20, 17, 14, 0.1);
  background: #fffdf8 !important;
}

.sli ::v-deep .picture-inner {
  font-size: 13px;
  font-weight: 600;
  color: #7a7268;
}
</style>
